import { ColumnType, ListingHelper } from 'src/app/core/utils/listing.helper';

import { Component, Input, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { StylesSmartTableComponent } from '@brafton/angular-styles-library';
import { IBaseProject } from '@brafton/common-framework-library';
import { IPagedList } from '@brafton/skynet-angular-security-service';

@Component({
  selector: 'shared-space-listing',
  templateUrl: './space-listing.component.html',
  styleUrls: ['./space-listing.component.scss'],
  host: { class: 'space-listing' },
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SharedSpacesListingComponent {
  @Input() spaces!: IPagedList<IBaseProject>;
  @Input() disableProgressLine = false;
  @Input() showProgress = true;
  @Input() showColumnHeaders = true;
  @Input() expandable!: boolean;

  @Input() get showOwner() {
    return this.columnBuilder.isShown('owner');
  }
  set showOwner(value: boolean) {
    this.columnBuilder.setShown('owner', value);
  }

  @Input() get showContentType() {
    return this.columnBuilder.isShown('contentType');
  }
  set showContentType(value: boolean) {
    this.columnBuilder.setShown('contentType', value);
  }

  @Input() get showDate() {
    return this.columnBuilder.isShown('date');
  }
  set showDate(value: boolean) {
    this.columnBuilder.setShown('date', value);
  }

  @Input() get showStatus() {
    return this.columnBuilder.isShown('status');
  }
  set showStatus(value: boolean) {
    this.columnBuilder.setShown('status', value);
  }

  @Input() get showImage() {
    return this.columnBuilder.isShown('image');
  }
  set showImage(value: boolean) {
    this.columnBuilder.setShown('image', value);
  }

  @Input() get showOrganization() {
    return this.columnBuilder.isShown('organization');
  }
  set showOrganization(value: boolean) {
    this.columnBuilder.setShown('organization', value);
  }

  @ViewChild('smartTable') smartTable!: StylesSmartTableComponent<any>;

  columnBuilder = new ListingHelper();

  constructor() {
    this.columnBuilder.addColumn('image', ColumnTypes.Small);
    this.columnBuilder.addDefaultColumn('default');
    this.columnBuilder.addColumn('organization', ColumnTypes.Large);
    this.columnBuilder.addColumn('owner', ColumnTypes.Medium);
    this.columnBuilder.addColumn('date', ColumnTypes.Medium);
    this.columnBuilder.addColumn('contentType', ColumnTypes.Medium);
    this.columnBuilder.addColumn('status', ColumnTypes.Medium);
  }
}

class ColumnTypes {
  static readonly Small: ColumnType = new ColumnType(5, 9);
  static readonly Medium: ColumnType = new ColumnType(12, 20);
  static readonly Large: ColumnType = new ColumnType(15, 24);
}
